export enum creneauxHorairesEnum {
	MATIN1 = 8,
	MATIN2 = 10,
	APREM1 = 14,
	APREM2 = 16,
}